import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainAllocationBaseFragment = { __typename?: 'DomainAllocationInfoWithName', domainAllocated: number, domainUsed: number };

export type UserPackageDomainAllocationQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type UserPackageDomainAllocationQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', userPackages: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, domainAllocated: number, domainUsed: number }> } };

export type UserPackageDomainAllocationSuperuserQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type UserPackageDomainAllocationSuperuserQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', userPackages: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, totalAllocated: number, systemLimit?: number | null, domainAllocated: number, domainUsed: number }> } };

export type DeviceTypeSetDomainAllocationQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DeviceTypeSetDomainAllocationQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', deviceTypeSets: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, domainAllocated: number, domainUsed: number }> } };

export type DeviceTypeSetDomainAllocationSuperuserQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DeviceTypeSetDomainAllocationSuperuserQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', deviceTypeSets: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, totalAllocated: number, systemLimit?: number | null, domainAllocated: number, domainUsed: number }> } };

export type CapabilitySetDomainAllocationQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type CapabilitySetDomainAllocationQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', capabilitySets: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, domainAllocated: number, domainUsed: number }> } };

export type CapabilitySetDomainAllocationSuperuserQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type CapabilitySetDomainAllocationSuperuserQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', capabilitySets: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, totalAllocated: number, systemLimit?: number | null, domainAllocated: number, domainUsed: number }> } };

export type ServiceDomainAllocationQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type ServiceDomainAllocationQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', services: { __typename?: 'ServiceDomainAllocationsInfo', fax: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number }, ccBase: { __typename?: 'SingleItemDomainAllocationInfo', domainAllocated: boolean, domainUsed: boolean }, ccAattendant: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number }, ccQueue: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number }, group5: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number }, group10: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number }, group20: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number } } } };

export type ServiceDomainAllocationSuperuserQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type ServiceDomainAllocationSuperuserQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', services: { __typename?: 'ServiceDomainAllocationsInfo', fax: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, totalAllocated: number, systemLimit?: number | null }, ccBase: { __typename?: 'SingleItemDomainAllocationInfo', domainAllocated: boolean, domainUsed: boolean, totalAllocated: number, systemLimit?: number | null }, ccAattendant: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, totalAllocated: number, systemLimit?: number | null }, ccQueue: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, totalAllocated: number, systemLimit?: number | null }, group5: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, totalAllocated: number, systemLimit?: number | null }, group10: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, totalAllocated: number, systemLimit?: number | null }, group20: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, totalAllocated: number, systemLimit?: number | null } } } };

export type DomainQuotaDefaultsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainQuotaDefaultsQuery = { __typename?: 'Query', domainQuotaDefaults?: { __typename?: 'DomainQuotaDefaultsInfo', defaultUserPackage?: string | null, availableUserPackages: Array<string>, defaultCapabilities?: Array<string> | null, availableCapabilities: Array<string>, defaultDevices: Array<{ __typename?: 'DefaultDevice', name: string, value: number, limit: number }> } | null };

export type DomainBulkCapabilityQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainBulkCapabilityQuery = { __typename?: 'Query', domainBulkCapability?: Array<{ __typename?: 'BulkCapabilityModificationInfo', capability: string, allocated: number, used: number, allowGrant: boolean } | null> | null };

export const DomainAllocationBaseFragmentDoc = gql`
    fragment DomainAllocationBase on DomainAllocationInfoWithName {
  domainAllocated
  domainUsed
}
    `;
export const UserPackageDomainAllocationDocument = gql`
    query UserPackageDomainAllocation($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    userPackages {
      name
      ...DomainAllocationBase
    }
  }
}
    ${DomainAllocationBaseFragmentDoc}`;

/**
 * __useUserPackageDomainAllocationQuery__
 *
 * To run a query within a React component, call `useUserPackageDomainAllocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPackageDomainAllocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPackageDomainAllocationQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useUserPackageDomainAllocationQuery(baseOptions: Apollo.QueryHookOptions<UserPackageDomainAllocationQuery, UserPackageDomainAllocationQueryVariables> & ({ variables: UserPackageDomainAllocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPackageDomainAllocationQuery, UserPackageDomainAllocationQueryVariables>(UserPackageDomainAllocationDocument, options);
      }
export function useUserPackageDomainAllocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPackageDomainAllocationQuery, UserPackageDomainAllocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPackageDomainAllocationQuery, UserPackageDomainAllocationQueryVariables>(UserPackageDomainAllocationDocument, options);
        }
export function useUserPackageDomainAllocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserPackageDomainAllocationQuery, UserPackageDomainAllocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserPackageDomainAllocationQuery, UserPackageDomainAllocationQueryVariables>(UserPackageDomainAllocationDocument, options);
        }
export type UserPackageDomainAllocationQueryHookResult = ReturnType<typeof useUserPackageDomainAllocationQuery>;
export type UserPackageDomainAllocationLazyQueryHookResult = ReturnType<typeof useUserPackageDomainAllocationLazyQuery>;
export type UserPackageDomainAllocationSuspenseQueryHookResult = ReturnType<typeof useUserPackageDomainAllocationSuspenseQuery>;
export type UserPackageDomainAllocationQueryResult = Apollo.QueryResult<UserPackageDomainAllocationQuery, UserPackageDomainAllocationQueryVariables>;
export const UserPackageDomainAllocationSuperuserDocument = gql`
    query UserPackageDomainAllocationSuperuser($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    userPackages {
      name
      ...DomainAllocationBase
      totalAllocated
      systemLimit
    }
  }
}
    ${DomainAllocationBaseFragmentDoc}`;

/**
 * __useUserPackageDomainAllocationSuperuserQuery__
 *
 * To run a query within a React component, call `useUserPackageDomainAllocationSuperuserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPackageDomainAllocationSuperuserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPackageDomainAllocationSuperuserQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useUserPackageDomainAllocationSuperuserQuery(baseOptions: Apollo.QueryHookOptions<UserPackageDomainAllocationSuperuserQuery, UserPackageDomainAllocationSuperuserQueryVariables> & ({ variables: UserPackageDomainAllocationSuperuserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPackageDomainAllocationSuperuserQuery, UserPackageDomainAllocationSuperuserQueryVariables>(UserPackageDomainAllocationSuperuserDocument, options);
      }
export function useUserPackageDomainAllocationSuperuserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPackageDomainAllocationSuperuserQuery, UserPackageDomainAllocationSuperuserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPackageDomainAllocationSuperuserQuery, UserPackageDomainAllocationSuperuserQueryVariables>(UserPackageDomainAllocationSuperuserDocument, options);
        }
export function useUserPackageDomainAllocationSuperuserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserPackageDomainAllocationSuperuserQuery, UserPackageDomainAllocationSuperuserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserPackageDomainAllocationSuperuserQuery, UserPackageDomainAllocationSuperuserQueryVariables>(UserPackageDomainAllocationSuperuserDocument, options);
        }
export type UserPackageDomainAllocationSuperuserQueryHookResult = ReturnType<typeof useUserPackageDomainAllocationSuperuserQuery>;
export type UserPackageDomainAllocationSuperuserLazyQueryHookResult = ReturnType<typeof useUserPackageDomainAllocationSuperuserLazyQuery>;
export type UserPackageDomainAllocationSuperuserSuspenseQueryHookResult = ReturnType<typeof useUserPackageDomainAllocationSuperuserSuspenseQuery>;
export type UserPackageDomainAllocationSuperuserQueryResult = Apollo.QueryResult<UserPackageDomainAllocationSuperuserQuery, UserPackageDomainAllocationSuperuserQueryVariables>;
export const DeviceTypeSetDomainAllocationDocument = gql`
    query DeviceTypeSetDomainAllocation($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    deviceTypeSets {
      name
      ...DomainAllocationBase
    }
  }
}
    ${DomainAllocationBaseFragmentDoc}`;

/**
 * __useDeviceTypeSetDomainAllocationQuery__
 *
 * To run a query within a React component, call `useDeviceTypeSetDomainAllocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceTypeSetDomainAllocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceTypeSetDomainAllocationQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDeviceTypeSetDomainAllocationQuery(baseOptions: Apollo.QueryHookOptions<DeviceTypeSetDomainAllocationQuery, DeviceTypeSetDomainAllocationQueryVariables> & ({ variables: DeviceTypeSetDomainAllocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceTypeSetDomainAllocationQuery, DeviceTypeSetDomainAllocationQueryVariables>(DeviceTypeSetDomainAllocationDocument, options);
      }
export function useDeviceTypeSetDomainAllocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceTypeSetDomainAllocationQuery, DeviceTypeSetDomainAllocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceTypeSetDomainAllocationQuery, DeviceTypeSetDomainAllocationQueryVariables>(DeviceTypeSetDomainAllocationDocument, options);
        }
export function useDeviceTypeSetDomainAllocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceTypeSetDomainAllocationQuery, DeviceTypeSetDomainAllocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceTypeSetDomainAllocationQuery, DeviceTypeSetDomainAllocationQueryVariables>(DeviceTypeSetDomainAllocationDocument, options);
        }
export type DeviceTypeSetDomainAllocationQueryHookResult = ReturnType<typeof useDeviceTypeSetDomainAllocationQuery>;
export type DeviceTypeSetDomainAllocationLazyQueryHookResult = ReturnType<typeof useDeviceTypeSetDomainAllocationLazyQuery>;
export type DeviceTypeSetDomainAllocationSuspenseQueryHookResult = ReturnType<typeof useDeviceTypeSetDomainAllocationSuspenseQuery>;
export type DeviceTypeSetDomainAllocationQueryResult = Apollo.QueryResult<DeviceTypeSetDomainAllocationQuery, DeviceTypeSetDomainAllocationQueryVariables>;
export const DeviceTypeSetDomainAllocationSuperuserDocument = gql`
    query DeviceTypeSetDomainAllocationSuperuser($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    deviceTypeSets {
      name
      ...DomainAllocationBase
      totalAllocated
      systemLimit
    }
  }
}
    ${DomainAllocationBaseFragmentDoc}`;

/**
 * __useDeviceTypeSetDomainAllocationSuperuserQuery__
 *
 * To run a query within a React component, call `useDeviceTypeSetDomainAllocationSuperuserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceTypeSetDomainAllocationSuperuserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceTypeSetDomainAllocationSuperuserQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDeviceTypeSetDomainAllocationSuperuserQuery(baseOptions: Apollo.QueryHookOptions<DeviceTypeSetDomainAllocationSuperuserQuery, DeviceTypeSetDomainAllocationSuperuserQueryVariables> & ({ variables: DeviceTypeSetDomainAllocationSuperuserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceTypeSetDomainAllocationSuperuserQuery, DeviceTypeSetDomainAllocationSuperuserQueryVariables>(DeviceTypeSetDomainAllocationSuperuserDocument, options);
      }
export function useDeviceTypeSetDomainAllocationSuperuserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceTypeSetDomainAllocationSuperuserQuery, DeviceTypeSetDomainAllocationSuperuserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceTypeSetDomainAllocationSuperuserQuery, DeviceTypeSetDomainAllocationSuperuserQueryVariables>(DeviceTypeSetDomainAllocationSuperuserDocument, options);
        }
export function useDeviceTypeSetDomainAllocationSuperuserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceTypeSetDomainAllocationSuperuserQuery, DeviceTypeSetDomainAllocationSuperuserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceTypeSetDomainAllocationSuperuserQuery, DeviceTypeSetDomainAllocationSuperuserQueryVariables>(DeviceTypeSetDomainAllocationSuperuserDocument, options);
        }
export type DeviceTypeSetDomainAllocationSuperuserQueryHookResult = ReturnType<typeof useDeviceTypeSetDomainAllocationSuperuserQuery>;
export type DeviceTypeSetDomainAllocationSuperuserLazyQueryHookResult = ReturnType<typeof useDeviceTypeSetDomainAllocationSuperuserLazyQuery>;
export type DeviceTypeSetDomainAllocationSuperuserSuspenseQueryHookResult = ReturnType<typeof useDeviceTypeSetDomainAllocationSuperuserSuspenseQuery>;
export type DeviceTypeSetDomainAllocationSuperuserQueryResult = Apollo.QueryResult<DeviceTypeSetDomainAllocationSuperuserQuery, DeviceTypeSetDomainAllocationSuperuserQueryVariables>;
export const CapabilitySetDomainAllocationDocument = gql`
    query CapabilitySetDomainAllocation($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    capabilitySets {
      name
      ...DomainAllocationBase
    }
  }
}
    ${DomainAllocationBaseFragmentDoc}`;

/**
 * __useCapabilitySetDomainAllocationQuery__
 *
 * To run a query within a React component, call `useCapabilitySetDomainAllocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapabilitySetDomainAllocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapabilitySetDomainAllocationQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useCapabilitySetDomainAllocationQuery(baseOptions: Apollo.QueryHookOptions<CapabilitySetDomainAllocationQuery, CapabilitySetDomainAllocationQueryVariables> & ({ variables: CapabilitySetDomainAllocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapabilitySetDomainAllocationQuery, CapabilitySetDomainAllocationQueryVariables>(CapabilitySetDomainAllocationDocument, options);
      }
export function useCapabilitySetDomainAllocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapabilitySetDomainAllocationQuery, CapabilitySetDomainAllocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapabilitySetDomainAllocationQuery, CapabilitySetDomainAllocationQueryVariables>(CapabilitySetDomainAllocationDocument, options);
        }
export function useCapabilitySetDomainAllocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CapabilitySetDomainAllocationQuery, CapabilitySetDomainAllocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CapabilitySetDomainAllocationQuery, CapabilitySetDomainAllocationQueryVariables>(CapabilitySetDomainAllocationDocument, options);
        }
export type CapabilitySetDomainAllocationQueryHookResult = ReturnType<typeof useCapabilitySetDomainAllocationQuery>;
export type CapabilitySetDomainAllocationLazyQueryHookResult = ReturnType<typeof useCapabilitySetDomainAllocationLazyQuery>;
export type CapabilitySetDomainAllocationSuspenseQueryHookResult = ReturnType<typeof useCapabilitySetDomainAllocationSuspenseQuery>;
export type CapabilitySetDomainAllocationQueryResult = Apollo.QueryResult<CapabilitySetDomainAllocationQuery, CapabilitySetDomainAllocationQueryVariables>;
export const CapabilitySetDomainAllocationSuperuserDocument = gql`
    query CapabilitySetDomainAllocationSuperuser($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    capabilitySets {
      name
      ...DomainAllocationBase
      totalAllocated
      systemLimit
    }
  }
}
    ${DomainAllocationBaseFragmentDoc}`;

/**
 * __useCapabilitySetDomainAllocationSuperuserQuery__
 *
 * To run a query within a React component, call `useCapabilitySetDomainAllocationSuperuserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapabilitySetDomainAllocationSuperuserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapabilitySetDomainAllocationSuperuserQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useCapabilitySetDomainAllocationSuperuserQuery(baseOptions: Apollo.QueryHookOptions<CapabilitySetDomainAllocationSuperuserQuery, CapabilitySetDomainAllocationSuperuserQueryVariables> & ({ variables: CapabilitySetDomainAllocationSuperuserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapabilitySetDomainAllocationSuperuserQuery, CapabilitySetDomainAllocationSuperuserQueryVariables>(CapabilitySetDomainAllocationSuperuserDocument, options);
      }
export function useCapabilitySetDomainAllocationSuperuserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapabilitySetDomainAllocationSuperuserQuery, CapabilitySetDomainAllocationSuperuserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapabilitySetDomainAllocationSuperuserQuery, CapabilitySetDomainAllocationSuperuserQueryVariables>(CapabilitySetDomainAllocationSuperuserDocument, options);
        }
export function useCapabilitySetDomainAllocationSuperuserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CapabilitySetDomainAllocationSuperuserQuery, CapabilitySetDomainAllocationSuperuserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CapabilitySetDomainAllocationSuperuserQuery, CapabilitySetDomainAllocationSuperuserQueryVariables>(CapabilitySetDomainAllocationSuperuserDocument, options);
        }
export type CapabilitySetDomainAllocationSuperuserQueryHookResult = ReturnType<typeof useCapabilitySetDomainAllocationSuperuserQuery>;
export type CapabilitySetDomainAllocationSuperuserLazyQueryHookResult = ReturnType<typeof useCapabilitySetDomainAllocationSuperuserLazyQuery>;
export type CapabilitySetDomainAllocationSuperuserSuspenseQueryHookResult = ReturnType<typeof useCapabilitySetDomainAllocationSuperuserSuspenseQuery>;
export type CapabilitySetDomainAllocationSuperuserQueryResult = Apollo.QueryResult<CapabilitySetDomainAllocationSuperuserQuery, CapabilitySetDomainAllocationSuperuserQueryVariables>;
export const ServiceDomainAllocationDocument = gql`
    query ServiceDomainAllocation($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    services {
      fax {
        domainAllocated
        domainUsed
      }
      ccBase {
        domainAllocated
        domainUsed
      }
      ccAattendant {
        domainAllocated
        domainUsed
      }
      ccQueue {
        domainAllocated
        domainUsed
      }
      group5 {
        domainAllocated
        domainUsed
      }
      group10 {
        domainAllocated
        domainUsed
      }
      group20 {
        domainAllocated
        domainUsed
      }
    }
  }
}
    `;

/**
 * __useServiceDomainAllocationQuery__
 *
 * To run a query within a React component, call `useServiceDomainAllocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceDomainAllocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceDomainAllocationQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useServiceDomainAllocationQuery(baseOptions: Apollo.QueryHookOptions<ServiceDomainAllocationQuery, ServiceDomainAllocationQueryVariables> & ({ variables: ServiceDomainAllocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceDomainAllocationQuery, ServiceDomainAllocationQueryVariables>(ServiceDomainAllocationDocument, options);
      }
export function useServiceDomainAllocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceDomainAllocationQuery, ServiceDomainAllocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceDomainAllocationQuery, ServiceDomainAllocationQueryVariables>(ServiceDomainAllocationDocument, options);
        }
export function useServiceDomainAllocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceDomainAllocationQuery, ServiceDomainAllocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceDomainAllocationQuery, ServiceDomainAllocationQueryVariables>(ServiceDomainAllocationDocument, options);
        }
export type ServiceDomainAllocationQueryHookResult = ReturnType<typeof useServiceDomainAllocationQuery>;
export type ServiceDomainAllocationLazyQueryHookResult = ReturnType<typeof useServiceDomainAllocationLazyQuery>;
export type ServiceDomainAllocationSuspenseQueryHookResult = ReturnType<typeof useServiceDomainAllocationSuspenseQuery>;
export type ServiceDomainAllocationQueryResult = Apollo.QueryResult<ServiceDomainAllocationQuery, ServiceDomainAllocationQueryVariables>;
export const ServiceDomainAllocationSuperuserDocument = gql`
    query ServiceDomainAllocationSuperuser($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    services {
      fax {
        domainAllocated
        domainUsed
        totalAllocated
        systemLimit
      }
      ccBase {
        domainAllocated
        domainUsed
        totalAllocated
        systemLimit
      }
      ccAattendant {
        domainAllocated
        domainUsed
        totalAllocated
        systemLimit
      }
      ccQueue {
        domainAllocated
        domainUsed
        totalAllocated
        systemLimit
      }
      group5 {
        domainAllocated
        domainUsed
        totalAllocated
        systemLimit
      }
      group10 {
        domainAllocated
        domainUsed
        totalAllocated
        systemLimit
      }
      group20 {
        domainAllocated
        domainUsed
        totalAllocated
        systemLimit
      }
    }
  }
}
    `;

/**
 * __useServiceDomainAllocationSuperuserQuery__
 *
 * To run a query within a React component, call `useServiceDomainAllocationSuperuserQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceDomainAllocationSuperuserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceDomainAllocationSuperuserQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useServiceDomainAllocationSuperuserQuery(baseOptions: Apollo.QueryHookOptions<ServiceDomainAllocationSuperuserQuery, ServiceDomainAllocationSuperuserQueryVariables> & ({ variables: ServiceDomainAllocationSuperuserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceDomainAllocationSuperuserQuery, ServiceDomainAllocationSuperuserQueryVariables>(ServiceDomainAllocationSuperuserDocument, options);
      }
export function useServiceDomainAllocationSuperuserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceDomainAllocationSuperuserQuery, ServiceDomainAllocationSuperuserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceDomainAllocationSuperuserQuery, ServiceDomainAllocationSuperuserQueryVariables>(ServiceDomainAllocationSuperuserDocument, options);
        }
export function useServiceDomainAllocationSuperuserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceDomainAllocationSuperuserQuery, ServiceDomainAllocationSuperuserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceDomainAllocationSuperuserQuery, ServiceDomainAllocationSuperuserQueryVariables>(ServiceDomainAllocationSuperuserDocument, options);
        }
export type ServiceDomainAllocationSuperuserQueryHookResult = ReturnType<typeof useServiceDomainAllocationSuperuserQuery>;
export type ServiceDomainAllocationSuperuserLazyQueryHookResult = ReturnType<typeof useServiceDomainAllocationSuperuserLazyQuery>;
export type ServiceDomainAllocationSuperuserSuspenseQueryHookResult = ReturnType<typeof useServiceDomainAllocationSuperuserSuspenseQuery>;
export type ServiceDomainAllocationSuperuserQueryResult = Apollo.QueryResult<ServiceDomainAllocationSuperuserQuery, ServiceDomainAllocationSuperuserQueryVariables>;
export const DomainQuotaDefaultsDocument = gql`
    query DomainQuotaDefaults($domainId: Int!) {
  domainQuotaDefaults(domainId: $domainId) {
    defaultUserPackage
    availableUserPackages
    defaultDevices {
      name
      value
      limit
    }
    defaultCapabilities
    availableCapabilities
  }
}
    `;

/**
 * __useDomainQuotaDefaultsQuery__
 *
 * To run a query within a React component, call `useDomainQuotaDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainQuotaDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainQuotaDefaultsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainQuotaDefaultsQuery(baseOptions: Apollo.QueryHookOptions<DomainQuotaDefaultsQuery, DomainQuotaDefaultsQueryVariables> & ({ variables: DomainQuotaDefaultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainQuotaDefaultsQuery, DomainQuotaDefaultsQueryVariables>(DomainQuotaDefaultsDocument, options);
      }
export function useDomainQuotaDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainQuotaDefaultsQuery, DomainQuotaDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainQuotaDefaultsQuery, DomainQuotaDefaultsQueryVariables>(DomainQuotaDefaultsDocument, options);
        }
export function useDomainQuotaDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainQuotaDefaultsQuery, DomainQuotaDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainQuotaDefaultsQuery, DomainQuotaDefaultsQueryVariables>(DomainQuotaDefaultsDocument, options);
        }
export type DomainQuotaDefaultsQueryHookResult = ReturnType<typeof useDomainQuotaDefaultsQuery>;
export type DomainQuotaDefaultsLazyQueryHookResult = ReturnType<typeof useDomainQuotaDefaultsLazyQuery>;
export type DomainQuotaDefaultsSuspenseQueryHookResult = ReturnType<typeof useDomainQuotaDefaultsSuspenseQuery>;
export type DomainQuotaDefaultsQueryResult = Apollo.QueryResult<DomainQuotaDefaultsQuery, DomainQuotaDefaultsQueryVariables>;
export const DomainBulkCapabilityDocument = gql`
    query DomainBulkCapability($domainId: Int!) {
  domainBulkCapability(domainId: $domainId) {
    capability
    allocated
    used
    allowGrant
  }
}
    `;

/**
 * __useDomainBulkCapabilityQuery__
 *
 * To run a query within a React component, call `useDomainBulkCapabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainBulkCapabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainBulkCapabilityQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainBulkCapabilityQuery(baseOptions: Apollo.QueryHookOptions<DomainBulkCapabilityQuery, DomainBulkCapabilityQueryVariables> & ({ variables: DomainBulkCapabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainBulkCapabilityQuery, DomainBulkCapabilityQueryVariables>(DomainBulkCapabilityDocument, options);
      }
export function useDomainBulkCapabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainBulkCapabilityQuery, DomainBulkCapabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainBulkCapabilityQuery, DomainBulkCapabilityQueryVariables>(DomainBulkCapabilityDocument, options);
        }
export function useDomainBulkCapabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainBulkCapabilityQuery, DomainBulkCapabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainBulkCapabilityQuery, DomainBulkCapabilityQueryVariables>(DomainBulkCapabilityDocument, options);
        }
export type DomainBulkCapabilityQueryHookResult = ReturnType<typeof useDomainBulkCapabilityQuery>;
export type DomainBulkCapabilityLazyQueryHookResult = ReturnType<typeof useDomainBulkCapabilityLazyQuery>;
export type DomainBulkCapabilitySuspenseQueryHookResult = ReturnType<typeof useDomainBulkCapabilitySuspenseQuery>;
export type DomainBulkCapabilityQueryResult = Apollo.QueryResult<DomainBulkCapabilityQuery, DomainBulkCapabilityQueryVariables>;